import { FC } from "react";
import cx from "classnames";
import CustomTooltip, { CustomTooltipType } from "./customTooltip/customTooltip";
import { PropertyVisualStyle, VehicleProperty } from "../../../types/site";
import { Vehicle } from "../../../types/vehicle";
import InfoIcon from "../../icons/info-icon";
import styles from "./vehicle-property-name.module.scss";

interface IVehiclePropertyNameView {
  className: string;
  property: VehicleProperty;
  vehicle: Vehicle;
  tooltipType?: CustomTooltipType;
}

function getPropertyNameSpan(property: VehicleProperty, titleClassName: string, vehicle?: Vehicle) {
  return (
    <span
      className={cx(titleClassName, styles.title, {
        [styles.preliminaryTitle]:
          property.visualStyle === PropertyVisualStyle.PRELIMINARY_PRICE ||
          property.visualStyle === PropertyVisualStyle.FINAL_PRICE,
        [styles.gray]:
          property.visualStyle === PropertyVisualStyle.PRELIMINARY_PRICE && vehicle?.finalPrice !== undefined,
      })}
    >
      {property.title}
    </span>
  );
}

const VehiclePropertyNameView: FC<IVehiclePropertyNameView> = ({ className, property, vehicle, tooltipType }) => {
  return property?.disclaimer ? (
    <div className={styles.tooltip}>
      <CustomTooltip
        target={
          <div className={styles.propertyContainer}>
            {getPropertyNameSpan(property, className, vehicle)}
            <div className={styles.infoIcon}>
              <InfoIcon />
            </div>
          </div>
        }
        title={property.disclaimer || ""}
        type={tooltipType}
      />
    </div>
  ) : (
    getPropertyNameSpan(property, className, vehicle)
  );
};

export default VehiclePropertyNameView;
